import { render, staticRenderFns } from "./q-title.vue?vue&type=template&id=0fc60e1a&scoped=true&"
import script from "./q-title.vue?vue&type=script&lang=js&"
export * from "./q-title.vue?vue&type=script&lang=js&"
import style0 from "./q-title.vue?vue&type=style&index=0&id=0fc60e1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc60e1a",
  null
  
)

export default component.exports